import { useEffect, useState } from 'react';
import { ProjectChat } from '../types';
import { subscribeToProjectChats } from '../services/chats';

export function useProjectChats(projectId: string | null) {
  const [chats, setChats] = useState<ProjectChat[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!projectId) {
      setChats([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    const unsubscribe = subscribeToProjectChats(projectId, (nextChats) => {
      setChats(nextChats);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [projectId]);

  return { chats, loading };
}
